"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.commonZodOperationNodeUtils = void 0;
const zod_1 = require("zod");
const common_1 = require("@finley-technologies/common");
const tape_builder_base_1 = require("../types/tape-builder-base");
const commonZodOperationNodeUtils = (nodeType, zodSchema, friendlyName) => {
    // Type Guard for Node
    const isNode = (obj) => {
        return obj.metadata.tapeBuilderNodeType === nodeType;
    };
    // Get friendly name
    const getFriendlyName = (_node) => {
        return friendlyName;
    };
    // Type Guard for Config
    const isConfig = (obj) => {
        const result = zodSchema.safeParse(obj);
        if (!result.success) {
            return false;
        }
        return true;
    };
    const getOperationNode = (node) => {
        (0, common_1.finleyAssert)(isNode(node), `must be a ${nodeType} node`);
        return node;
    };
    return {
        isOperation: true,
        nodeTypeText: friendlyName,
        badgeTexts: [],
        isNode,
        getFriendlyName,
        isConfig,
        getOperationNode,
        getJsonSchema: () => {
            // default schema generated by zod is not compatible with Monaco editor
            // Monaco editor does not support Draft Draft 2020-12 yet.
            // strip the internal slug-ref marker so the admin editor sees plain strings.
            return (0, tape_builder_base_1.stripArtifactSlugRefMarker)(zod_1.z.toJSONSchema(zodSchema, { target: 'draft-7' }));
        },
    };
};
exports.commonZodOperationNodeUtils = commonZodOperationNodeUtils;
//# sourceMappingURL=commonOperationNode.js.map